var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lib-dropdown" },
    [
      _c("lib-select", {
        attrs: {
          options: _vm.options,
          value: _vm.value,
          "right-aligned": true,
        },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "selected",
            fn: function (props) {
              return [
                _c("div", { staticClass: "explanation" }, [
                  _vm._v(_vm._s(_vm.explanation ? _vm.explanation : "")),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "description" }, [
                  _vm._v(_vm._s(props.option.description)),
                ]),
              ]
            },
          },
          {
            key: "descriptions",
            fn: function (props) {
              return [
                props.option.other
                  ? _c("span", { staticClass: "other" }, [
                      _vm._v(_vm._s(props.option.other)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "description" }, [
                  _vm._v(_vm._s(props.option.description)),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }